<template>
  <section class="lyrics-box nano" ref="wrap">
    <div class="nano-content">
      <ul class="lyric-box" ref="lyricsBox" v-show="!isLyricsAnimateLoading" />
      <v-spinner v-if="isLyricsAnimateLoading" />
    </div>
  </section>
</template>

<script>
import "./index.scss";
import { replace_from } from "./utils";
import Lyrics from "@/vendor/lyrics.min";
import { mapGetters } from "vuex";
export default {
  inject: ["comps", "data"],
  computed: {
    ...mapGetters("global", ["apiUri"]),
  },
  data() {
    this.prevIndex = 0;
    this.L = null;
    return { isLyricsAnimateLoading: true };
  },
  mounted() {
    setTimeout(() => {
      this.init();
    }, 600);
  },
  beforeDestroy() {
    this.L.destroy();
  },
  methods: {
    init() {
      this.L = new Lyrics({
        el: this.$refs.lyricsBox,
        detectFrom: replace_from,
        fixBreakLine: true,
        lrcLoadTimeout: 15000,
      });

      this.event_handle();

      this.load_lyrics(this.data.lists[0].lrcUri);
    },
    event_handle() {
      let VAudioObject = this.comps().controls.VAudioObject;
      VAudioObject.on(
        "watcherUpdate",
        (ev, currentTime, percentage, duration, isEnded) => {
          this.on_watcher_update(currentTime);
        }
      );

      this.L.on("lrcLoaded", () => {
        setTimeout(() => {
          $(this.$refs.lyricsBox).html(
            this.$P.uni2zg($(this.$refs.lyricsBox).html())
          );
          setTimeout(() => {
            $(this.$refs.wrap).nanoScroller();
          }, 400);
        }, 600);
      });
    },
    on_watcher_update(currentTime) {
      this.lyrics_scroll(currentTime, false, true);
    },
    lyrics_scroll(currentTime, isForce = false, isBasicScroll = false) {
      let currentLrcObj = this.L.check(currentTime);
      if (currentLrcObj) {
        if (isForce || this.prevIndex != currentLrcObj.index) {
          this.scroll_animate(currentLrcObj.index, isBasicScroll);
          this.prevIndex = currentLrcObj.index;
        }
      }
    },
    scroll_animate(index, isBasicScroll) {
      let $lrcItems = $(this.$refs.lyricsBox).find("li");

      if ($lrcItems.length > 0) {
        let $nowItem = $lrcItems.eq(index);
        if ($nowItem.length === 0) return;
        $nowItem.addClass("on").siblings().removeClass("on");

        let parent = $(this.$refs.lyricsBox).parent();
        let parentHeight = parent.outerHeight();
        let half = parentHeight / 2;
        let height = $nowItem.outerHeight();

        $nowItem.velocity("scroll", {
          container: parent,
          duration: isBasicScroll ? 450 : 0,
          easing: "easeInOutQuad",
          offset: ((height + half) / 2 + height) * -1,
          delay: 0,
        });
      }
    },
    load_lyrics(lrc) {
      this.isLyricsAnimateLoading = true;
      $(this.$refs.wrap).nanoScroller({ scrollTop: 0 });
      this.L.load_promise(
        (process.env.NODE_ENV === "development"
          ? `http://localhost:8888/`
          : "") + this.get_lrc_remote_link(lrc)
      ).then(() => {
        this.isLyricsAnimateLoading = false;
      });
    },
    get_lrc_remote_link(lrcPath) {
      return (
        this.apiUri +
        `?${$.param({
          lrc: lrcPath,
          action: "gp_home_ajax",
          page_name: "page-hymns",
          page_method: "getLrc",
        })}`
      );
    },
  },
};
</script>
